export default __webpack_public_path__ + "static/media/ic-telegram-app.88fd42a1.svg";